export default __webpack_public_path__ + "static/media/add-icon.b4badd62.webp";